import type { ComputedRef } from 'vue'
import { creerCacheImages } from '@/composables/useImageVersionnee'
import { fetchAvatar } from '@/services/personnes.service'

/* Photos de profil, chargées une fois par (personne, version) pour toute l'app : voir creerCacheImages. */
const avatars = creerCacheImages(fetchAvatar)

/** Révoque les URL de toutes les versions de la personne (après l'envoi ou le retrait de sa photo). */
export function oublierAvatar(personneId: string): void {
  avatars.oublier(personneId)
}

/** URL de la photo, `undefined` sans photo, pendant le chargement ou en cas d'échec (on affiche les initiales). */
export function useAvatar(personne: () => { id?: string; avatarVersion?: string }): ComputedRef<string | undefined> {
  return avatars.use(() => ({ id: personne().id, version: personne().avatarVersion }))
}
